/**
 * @generated SignedSource<<e55c221ef944489fbce4b82aa2e788a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditMain_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditMainDocuments_data" | "PackageEditMainGeneral_data" | "PackageEditMainPresentation_data" | "PackageEditMainTerms_data">;
  readonly " $fragmentType": "PackageEditMain_data";
};
export type PackageEditMain_data$key = {
  readonly " $data"?: PackageEditMain_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditMain_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditMain_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditMainGeneral_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditMainPresentation_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditMainTerms_data"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageEditMainDocuments_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "a6dd44047b80c3f8e8a1f1278673ccdb";

export default node;
